import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Workflow, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function UseCasesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/catalog/usecases").then((r) => setItems(r.data.items || [])); }, []);

  const groups = items.reduce((acc, u) => {
    const g = u.kullanim_grubu || "Diğer";
    (acc[g] = acc[g] || []).push(u);
    return acc;
  }, {});

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-head text-3xl font-bold text-slate-900 mb-2">Kullanım Alanına Göre</h1>
      <p className="text-slate-500 mb-8 max-w-2xl">İşlevsel kullanım alanlarına göre ürünleri inceleyin.</p>
      <div className="space-y-8">
        {Object.entries(groups).map(([g, list]) => (
          <div key={g}>
            <h2 className="font-head text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2">
              <Workflow className="w-4 h-4 text-teal-600" /> {g}
            </h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {list.map((u) => (
                <Link key={u.kullanim_id} to={`/urunler?kullanim=${u.kullanim_id}`} data-testid={`usecase-${u.kullanim_id}`}
                  className="group bg-white border border-slate-200 rounded-lg p-4 hover:border-teal-400 transition-all flex items-center gap-2">
                  <span className="text-sm font-medium text-slate-800 group-hover:text-teal-700">{u.kullanim_adi_tr}</span>
                  <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-teal-500 ml-auto" />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
